export default () => ({
  saved: false,
  show: false,
  beenUpdated: false,
  wasRaised: false,
  prefixRouter: 'professional.addresses',
  entity: 'address',
  entities: 'addresses',
  addresses: [],
  address: {
    attachment: {
      content: null,
      mime: null
    },
    name: null,
    zip: null,
    street: null,
    number: null,
    complement: null,
    district: null,
    city: null,
    state: null,
    phones: [],
    parking: 'yes',
    email: null
  },
  errors: {
  },
  phone: {
    type: 'work',
    number: null,
    exten: null
  },
  parkingOptions: [
    {
      id: 'yes',
      label: 'Próprio'
    },
    {
      id: 'covenant',
      label: 'Conveniado'
    },
    {
      id: 'paid',
      label: 'Pago (nas proximidades)'
    },
    {
      id: 'no',
      label: 'Não há'
    }
  ],
  phoneTypesOptions: [
    {
      id: 'work',
      label: 'Comercial'
    },
    {
      id: 'mobile',
      label: 'Celular'
    },
    {
      id: 'fax',
      label: 'FAX'
    }
  ],
  nextStepButtonCompanyAddresses: [
    {
      icon: '',
      text: 'Novo Local de Atendimento',
      name: 'professional.company.addresses.create',
      action: true
    },
    {
      icon: '',
      text: 'Convênios Médicos',
      name: 'professional.company.covenants.create',
      action: null
    }
  ],
  nextStepButtonIsCompanyAddresses: [
    {
      icon: '',
      text: 'Novo Local de Atendimento',
      name: 'professional.company.addresses.create',
      action: true
    },
    {
      icon: '',
      text: 'Convênios Médicos',
      name: 'professional.company.covenants.create',
      action: null
    },
    {
      icon: '',
      text: 'Corpo Clínico',
      name: 'professional.company.staffs.create',
      action: null
    }
  ]
})



// WEBPACK FOOTER //
// ./src/app/professional/company/addresses/resources/data.js